import { styled } from 'styled-components';

interface CoverProps {
    background?: string;
    height?: string;
}
type iconTypeProps ='square' | 'rectangle'
interface IconProps {
    type?: iconTypeProps;
}

export const EditBox = styled.div`
    position: absolute;
    top: 15px;
    right: -60px;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease-in-out;
    z-index: 2;
    width:30px;
    height: 30px;
    background: ${({ theme }) => theme.colors.card.background};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};
`;

export const DeleteBox = styled.div`
    position: absolute;
    top: 35px;
    right: -60px;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease-in-out;
    z-index: 1;
    width:30px;
    height: 30px;
    background: ${({ theme }) => theme.colors.danger[500]};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};
`;

export const VideoCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    &:hover ${EditBox} {
        right: 15px;
        top: 15px;
        bottom: auto;
        opacity: 1;
        pointer-events: auto;
        transform: translate(0%, 0%);
    }
    &:hover ${DeleteBox} {
        right: 15px;
        top:55px;
        bottom: auto;
        opacity: 1;
        pointer-events: auto;
        transform: translate(0%, 0%);
    }
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};
`;

export const Cover = styled.div<CoverProps>`
    width: 100%;
    height: ${(props) => props.height || '200px'};
    overflow: hidden;
    position: relative;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-image: url(${(props) => props.background});
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
    cursor: pointer;
`;

export const VideoCardBox = styled.div`
    width: 100%;
    height: auto;
    background: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(36, 42, 51, 0.9)'
    : 'rgba(255, 255, 255, 0.6)')};
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding:  20px 15px;
    position:relative;
`;

export const Icon = styled.img`
    position: absolute;
    top: 15px;
    left: 15px;
    border-radius: 6px;
    width: 80px;
    height: 80px;
`;

export const Title = styled.h3`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.primary};
    line-height: 1.7;
`;

export const IconWrapper = styled.div<IconProps>`
    width: auto;
    padding: 5px 10px;
    height: 35px;
    position: absolute;
    bottom: 15px;
    left: 10px;
    border-radius: ${(props) => (props.type === 'square' ? '50%' : '6px')};
    background: rgba(0, 0, 0, 0.8);
    border:1px solid  rgba(255, 255, 255, 0.7);
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(225, 229, 238, 0.1) 0 2px 6px')};
    display: flex;
    font-size: 12px;
    align-items: center;
    font-weight: bold;
    color: #fff;
    justify-content: center;
`;

export const StatusWrapper = styled.div`
    position: absolute;
    top: 15px;
    left: 10px;
`;
